import { createAsyncThunk } from "@reduxjs/toolkit"
import { apim } from "@/constants/api"
import { MY_SERVICES_ENDPOINT } from "@/constants/index"

export const getServices = createAsyncThunk("getServices", async () => {
  let serviceList = []
  try {
    const res = await apim.get(`${MY_SERVICES_ENDPOINT}`)
    if (res && res.data && res.data.results) {
      serviceList = res.data.results
    }
  } catch (err) {
    console.error("Failed to fetch past orders", err)
  }

  return serviceList
})
